import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService} from '@app/secure/notification/notification.service';
import { Notification} from '@app/secure/model/Notification';
import { NotificationType} from '@app/secure/model/NotificationType';

@Component
({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
class NotificationComponent implements OnInit 
{
    notifications: Notification[] = [];
    private subscription: Subscription;

    constructor
    (
        private notificationSvc: NotificationService
    ) 
    {           
    }

    private addNotification
    (
        notification: Notification
    )
    {
        this.notifications.push(notification);
        
        if (notification.timeout !== 0)
        {
            setTimeout(() => this.close(notification), 
                             notification.timeout);
        }
    }
    
    ngOnInit(): void 
    {
        this.subscription = this.notificationSvc.getObservable().
                            subscribe(notification=> 
                                      this.addNotification(notification));
    }
    
    ngOnDestroy()
    {
        this.subscription.unsubscribe();
    }
    
    close
    (
        notification
    )
    {
        this.notifications = 
            this.notifications.filter(notif => notif.id !== notification.id);    
    }
    
    className
    (
        notification: Notification    
    ): string
    {
        let style: string;
    
        switch(notification.type)
        {
            case NotificationType.SUCCESS:
                style='success';
                break;
            case NotificationType.WARNING:
                style='warning';
                break;
            case NotificationType.ERROR:
                style='error';
                break;
            default:
                style='info';
                break;
            // end case                
        }
        
        return style;    
    }
}

export { NotificationComponent };
